export enum CreditTiersQueryKeys {
  All = "creditTiers",
  Single = "creditTier",
}
